/**
 * Phase D — Legacy class migration.
 *
 * When a slug is listed here, the DB row is the ONLY source of truth for that
 * class. The corresponding entry in `src/data/classes.ts` (if still present)
 * must be ignored at runtime everywhere the two lists are combined.
 *
 * Add a slug only after DB parity has been verified (public card, detail
 * dialog, calendar, registration form, admin editor, instructor display).
 */
export const migratedSlugs: ReadonlySet<string> = new Set<string>([
  // Batch 1 — pilot
  "beginners-basketball",
  "lego-robotics",
  "beginners-mechanics",
  "biology-lake-mead",
  // Dam Good Cruisers was already DB-only before Phase D
  "dam-good-cruisers-e-bike-club",
  // Batch 2
  "pokemon-club",
  "mommy-me-crochet",
  "chess-club",
  "all-about-farming",
  "hooved-and-hens",
  // Batch 3 — final legacy migration (src/data/classes.ts is now reference-only)
  "mommy-me-baking-2",
  "pe-class",
  "mommy-me-self-defense",
  "mommy-me-line-dancing",
  "photography-for-teens",
  "beginners-woodworking",
  "beginners-metal-working",
  "beginners-metalworking",
  "intro-to-choir",
  "improv-for-beginners",
  "beginners-volleyball",
]);


export function isMigrated(slug: string): boolean {
  return migratedSlugs.has(slug);
}
